/* eslint-disable no-console */
/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
// @ts-nocheck
import React from 'react';
// eslint-disable-next-line no-unused-vars
import DataTable from 'react-table';
// eslint-disable-next-line no-unused-vars
import Tabbar from '../../Components/Tabbar/Tabbar';
import 'react-table/react-table.css';
import axios from 'axios';
// eslint-disable-next-line no-unused-vars
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// eslint-disable-next-line no-unused-vars
import Loader from 'react-loader-spinner';
import formatDate from 'dateformat';
import '../Search/historical.css';
import {
	// eslint-disable-next-line no-unused-vars
	getAll,

} from '../../Store/Actions/RestActions';
// eslint-disable-next-line no-unused-vars
import PageFilter from '../../Components/Pages/PageFilter';
import {
	// eslint-disable-next-line no-unused-vars
	connect,
} from 'react-redux';
import { mainUrl } from '../../Constants';
import { redirectPathSet } from '../../Store/Actions/LoginActions';


const roomUrl = mainUrl + 'accounts/1/rooms';
const roomTypeUrl = mainUrl + 'accounts/1/roomtypes';
const reservationTypeUrl = mainUrl + 'accounts/1/reservationtypes';
const schedulerEventSearchUrl = mainUrl + 'accounts/1/scheduledeventssearch';



var bId;

class Historical extends React.Component {

	constructor(props) {
		super(props);
		this.state = {

			count: 0,
			visible: false,
			showing: false,
			showInstructions: true,
			showDownload: false,
			data: [],
			rooms: [],
			selected: '',
			selectedRoomType: '',
			selectedReservationType: '',
			roomTypes: [],
			reservationTypes: [],
			roomId: 0,
			buildingId: 0,
			roomTypeId: 0,
			reservationTypeId: 0,
			startDate: null,
			endDate: null,
			roomType: '',
			title: '',
			description: '',
			createdBy: '',
			dateCreated: '',
			dateModified: '',
			modifiedBy: '',
			tableData: [{
				id: '',
				title: '',
				description: '',
				roomId: 0,
				buildingId: 0,
				roomDescription: '',
				reservationType: [],
				roomName: '',
				createdBy: '',
				modifiedBy: '',
				dateCreated: '',
			    dateModified: '',
				start: '',
				end: '',
				assets: [],
				invitees: [],
				floorNumber: '',
				recurrences: [],
			}],
		};

		this.downloadCSV = this.downloadCSV.bind(this);
		this.handleEndDateChange = this.handleEndDateChange.bind(this);
		this.handleRoomChange = this.handleRoomChange.bind(this);
		this.handleRoomTypeChange = this.handleRoomTypeChange.bind(this);
		this.handleReservationTypeChange = this.handleReservationTypeChange.bind(this);
		this.handleStartDateChange = this.handleStartDateChange.bind(this);
		this.getSchedules = this.getSchedules.bind(this);
		this.getBrowserType = this.getBrowserType.bind(this);
		this.handleUserExport = this.handleUserExport.bind(this);
	}

	// api call loads all supporting data for dropdowns
	componentDidMount() {
		// api call for the rooms dropdown
		let initialRooms = [];
		fetch(roomUrl, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem('id_token')}`,
				'Content-Type': 'application/json',
			}
		})
			.then(response => {
				return response.json();
			}).then(data => {
				initialRooms = data.map((room) => {
					return room;
				});
				this.setState({
					rooms: initialRooms,
				});
			});


		// api call for the roomType dropdown
		let initialRoomTypes = [];
		fetch(roomTypeUrl, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem('id_token')}`,
				'Content-Type': 'application/json',
			}
		})
			.then(response => {
				return response.json();
			}).then(data => {
				initialRoomTypes = data.map((roomTypes) => {
					return roomTypes;
				});
				this.setState({
					roomTypes: initialRoomTypes,
				});
			});


		// api call for the reservationType dropdown
		let initialReservationTypes = [];
		fetch(reservationTypeUrl, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem('id_token')}`,
				'Content-Type': 'application/json',
			}
		})
			.then(response => {
				return response.json();
			}).then(data => {
				initialReservationTypes = data.map((reservationTypes) => {
					return reservationTypes;
				});
				this.setState({
					reservationTypes: initialReservationTypes,
				});
			});

		// set all dropdown Id's to 0 if not selected
		this.roomId = 0;
		this.roomTypeId = 0;
		this.reservationTypeId = 0;
	}

	// change event for start date
	handleStartDateChange(date) {
		this.setState({
			startDate: date
		});
	}


	// change event for end date
	handleEndDateChange(date) {
		this.setState({
			endDate: date
		});
	}


	// change event for title texarea
	handleTitleChange(e) {
		this.title = e.target.value;
		this.setState({ value: e.target.value });
	}


	// change event for description texarea
	handleDescriptionChange(e) {
		this.description = e.target.value;
		this.setState({ value: e.target.value });
	}


	// change event for rooms
	handleRoomChange(e) {
		for (let node of e.target.children) {
			if (node.value === e.target.value) {
				this.setState({ selected: e.target.value });
				this.roomId = node.getAttribute('room-id');
				this.buildingId = node.getAttribute('building-id');
				if (this.roomId === null) {
					this.roomId = 0;
				}
			}
		}
	}


	// change event for roomTypes
	handleRoomTypeChange(e) {
		for (let node of e.target.children) {
			if (node.value === e.target.value) {
				this.setState({ selectedRoomType: e.target.value });
				this.roomTypeId = node.getAttribute('roomtypes-id');
				if (this.roomTypeId === null) {
					this.roomTypeId = 0;
				}

			}
		}
	}


	// change event for reservationTypes
	handleReservationTypeChange(e) {
		for (let node of e.target.children) {
			if (node.value === e.target.value) {
				this.setState({ selectedReservationType: e.target.value });
				this.reservationTypeId = node.getAttribute('reservationtype-id');
				if (this.reservationTypeId === null) {
					this.reservationTypeId = 0;
				}

			}
		}
	}

	handleUserExport() {
		var browser = this.getBrowserType();
		this.downloadCSV(browser);
    	
	}

	getBrowserType(browser) {
             
		let objOffsetVersion = 0;
		var objAgent = navigator.userAgent; 
		var objbrowserName = navigator.appName; 
	
		// In Chrome 
		if ((objOffsetVersion=objAgent.indexOf("Chrome"))!==-1)  { 
			objbrowserName = "Chrome";
		} 
		
		// In Microsoft internet explorer 
		else if ((objOffsetVersion=objAgent.indexOf("MSIE"))!==-1) { 
			objbrowserName = "Microsoft Internet Explorer"; 
		} 

		// In Firefox 
		else if ((objOffsetVersion=objAgent.indexOf("Firefox"))!==-1) { 
			objbrowserName = "Firefox"; 
		} 
		
		// In Safari 
		else if ((objOffsetVersion=objAgent.indexOf("Safari"))!==-1) { 
		objbrowserName = "Safari"; 
		}
	   return objbrowserName;
	  }




	// one-off csv creator to handle dropdown data - JJ.   
	downloadCSV(browser) {
		
		var _title = "";
		var _description = "";
		var _createdby = "";
		var _modifiedby = "";

		var _recurrences;
		var _assets;
		var _invitees;
		var _reservationtype;
		const { tableData } = this.state;
		const headers = ['START', 'END', 'BUILDING NAME', 'ROOM NAME', 'TITLE', 'DESCRIPTION', 'RESERVATION TYPE', 'CREATED BY', 'DATE CREATED', 'MODIFIED BY',  'DATE MODIFIED', 'RECURRENCES', 'INVITEES', 'RESOURCES'];
		var h = "";
		
		var dateObj = new Date();
		var month = dateObj.getMonth() + 1;
		if(month < 10)
			month = "0" + month;
		var day = dateObj.getDate();
		 if(day < 10)
		    day = "0" + day.toString();
		var year = dateObj.getFullYear();
		var newDate = year.toString() +  month.toString() +  day.toString();
		var fileData;
		var spacer = "    ";
		var assetTabs = "\t\t\t\t\t\t\t\t";
		var inviteeTabs = "\t\t\t\t\t\t\t\t\t";
		var recurrenceTabs = "\t\t\t\t\t\t\t\t\t\t";
		var data;
		var link;

		// add our headers
		for (var x = 0; x < headers.length; x++) {
			h = h + headers[x] + ",";
			fileData = h;
		}
		
		// iterate through table data
		for (var index = 0; index < tableData.length; index++) {


			// handle any assets from dropdown
			_assets = tableData[index].assets.map((a) => {
				return (
					[a.name, "\n", assetTabs].join('')
				);
			}
			);

			// handle any invitees from dropdown
			_invitees = tableData[index].invitees.map((i) => {
				return (
					["Name:", i.firstName, spacer, i.lastName, "\n", inviteeTabs].join('')
				);
			}
			);

			// handle any recurrences from dopdown
			_recurrences = tableData[index].recurrences.map((r) => {
				return (
					["Start:", formatDate(r.start, 'mm/dd/yy hh:MM TT'), spacer, "End:", formatDate(r.end, 'mm/dd/yy hh:MM TT'), "\n", recurrenceTabs].join('')
				);

			}
			);

            
			_reservationtype = tableData[index].reservationType.name;
			if (_reservationtype == null)
				_reservationtype = " ";

			_createdby = tableData[index].createdBy;
			if (_createdby == null)
				_createdby = " ";

			_modifiedby = tableData[index].modifiedBy;
			if (_modifiedby == null)
			    _modifiedby = " ";


			_title = tableData[index].title;
			if (_title == null)
				_title = " ";

			_description = tableData[index].description;
			if (_description == null)
				_description = " ";

			// build the csv data string
			fileData = fileData + "\n" + formatDate(tableData[index].start, 'mm/dd/yy hh:MM TT') + "," + formatDate(tableData[index].end ,'mm/dd/yy hh:MM TT') + ","  + tableData[index].buildingName.replace(",", " ") + "," +
			tableData[index].roomName.replace(",", " ") + "," +   _title.replace(",", " ") + "," + _description.replace(",", " ") + "," +
			_reservationtype + "," + _createdby.replace(",", " ") + "," + formatDate(tableData[index].dateCreated, 'mm/dd/yy hh:MM TT') + "," + 
			_modifiedby.replace(",", " ") + "," + formatDate(tableData[index].dateModified, 'mm/dd/yy hh:MM TT') + "," +
			_recurrences.join('') + "," + + _invitees.join('') + "," + + _assets.join('');
			
		}


		let csvFileName = "ScheduleEvents-" + newDate + ".csv";

		if (window.navigator.msSaveBlob) {
			//Internet Explorer
			window.navigator.msSaveBlob(new Blob([fileData]), csvFileName);
		} 
		
		if (browser === "Chrome") {
			//Google Chrome and Mozilla Firefox
			var a = document.createElement("a");
			fileData = encodeURIComponent(fileData);
			a.href = "data:application/csv;charset=UTF-8," + fileData;
			a.download = csvFileName;
			a.click();
		} 

		if(browser === "Firefox"){
		if (!fileData.match(/^data:text\/csv/i)) {
				fileData = 'data:text/csv;charset=utf-8,' + '\uFEFF' + fileData;
		}
			data = encodeURI(fileData);
			link = document.createElement('a');
			link.setAttribute('href', data);
			link.setAttribute('download', csvFileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			}
		

		 if (navigator.appName === "Microsoft Internet Explorer") {
			//Internet Explorer 8 and 9
			var oWin = window.open();
			oWin.document.write("sep=,\r\n" + fileData);
			oWin.document.close();
			oWin.document.execCommand("SaveAs", true, csvFileName);
			oWin.close();
		} 

	}

	// api call to populate table based on search criteria
	getSchedules() {
		
		this.data = {
			Start: this.state.startDate,
			End: this.state.endDate,
			Title: this.title,
			Description: this.description,
			RoomId: parseInt(this.roomId),
			BuildingId: parseInt(this.buildingId),
			RoomTypeId: parseInt(this.roomTypeId),
			ReservationType: { Id: parseInt(this.reservationTypeId) }
		};

	
		
		this.setState({ showing: true, showDownload: false, visible: false });
		axios.post(schedulerEventSearchUrl, JSON.stringify(this.data), {
			headers: {
				Authorization: `Bearer ${localStorage.getItem('id_token')}`,
				'Content-Type': 'application/json',
			}
		})

			.then((response) => {
				this.setState({ tableData: response.data, showing: false, showDownload: true, showInstructions: false, visible: true });
				// this.setState({ showing: false });
			})
			.catch((error) => {
				this.setState({ showing: false, showInstructions: true, showDownload: false, visible: false });
				alert("ERROR: " + error.response.data);
			});
	}

	render() {
		const { showing } = this.state;
		const { showInstructions } = this.state;
		const { showDownload } = this.state;
		const { visible } = this.state;
		const { tableData } = this.state;
    
		
		const columns = [

			{
				columns: [
					{
						Header: 'Start',
						accessor: 'start',
						width: 170,
						Cell:  cellInfo => ( <div>{formatDate(cellInfo.original.start,  'mm/dd/yy hh:MM TT')} </div>
						)
					},
					{
						Header: 'End',
						accessor: 'end',
						width: 170,
						Cell:  cellInfo => ( <div>{formatDate(cellInfo.original.end,  'mm/dd/yy hh:MM TT')} </div>
						)
					},
				],
			},


			{
				columns: [
					{
						Header: 'Building Name',
						accessor: 'buildingName',
						width: 150,
					},
				],
			},




			{
				columns: [
					{
						Header: 'Room Name',
						accessor: 'roomName',
						width: 150,

					},
					
				],
			},


			{
				columns: [
					{
						Header: 'Title',
						accessor: 'title',
						width: 150,
					},
					{
						Header: 'Description',
						accessor: 'description',
						width: 150,
					},
				],
			},


			{
				columns: [
					{
						Header: 'Reservation Type',
						accessor: 'reservationType.name',
						width: 150,
					},
				],
			},
					{
				columns: [
					{
						Header: 'Created By',
						accessor: 'createdBy',
						width: 150,

					},
				],
			},

			{
				columns: [
					{
						Header: 'Date Created',
						accessor: 'dateCreated',
						width: 150,
						Cell:  cellInfo => ( <div>{formatDate(cellInfo.original.dateCreated,  'mm/dd/yy hh:MM TT')} </div>
						)

					},
				],
			},


			{
				columns: [
					{
						Header: 'Modified By',
						accessor: 'modifiedBy',
						width: 150,

					},
				],
			},


			{
				columns: [
					{
						Header: 'Date Modified',
						accessor: 'dateModified',
						width: 150,
						Cell:  cellInfo => ( <div>{formatDate(cellInfo.original.dateModified,  'mm/dd/yy hh:MM TT')} </div>
						)

					},
				],
			},



			{
				columns: [
					{
						Header: 'Recurrences',
						accessor: 'recurrences',
						width: 150,
						Cell: row => {
							var items = tableData[row.index].recurrences.map(function (item, i) {
								return (
									<option className="selectClass" key={i}>Start: {formatDate(item.start, 'mm/dd/yy hh:MM TT')} End: {formatDate(item.end, 'mm/dd/yy hh:MM TT')}</option>
								);
							}
							);
							return (
								<div>
									<select className="selectClass">
										{items}
									</select>
								</div>
							);

						}
					},

				],
			},


			{
				columns: [
					{
						Header: 'Invitees',
						accessor: 'invitees',
						width: 150,
						Cell: row => {
							var items = tableData[row.index].invitees.map(function (item, i) {
								return (
									<option className="selectClass" key={i}>{item.firstName} {item.lastName} </option>
								);
							}
							);
							return (
								<div>
									<select className="selectClass">
										{items}
									</select>
								</div>
							);

						}
					},

				],
			},



			{
				columns: [
					{
						Header: 'Resources',
						accessor: 'assets',
						width: 150,
						Cell: row => {
							var items = tableData[row.index].assets.map(function (item, i) {
								return (
									<option className="selectClass" key={i}>{item.name} </option>
								);
							}
							);
							return (
								<div>
									<select className="selectClass">
										{items}
									</select>
								</div>
							);

						}
					},   

				],
			},
	

		];
		return (
			<div className="container roomsIndex">
				<Tabbar setActiveTab="search" />
				<div className="contentBox tabbed-content-box no-padding">

					<div className="tableContainer">
						<div className="searchInstructions" style={{ display: (showInstructions ? 'block' : 'none') }}>
							Configure your search criteria using the search options on the lefthand side.
				 </div>
						<div id="#style-4" style={{ display: (visible ? 'block' : 'none') }}>
							<DataTable
							filterable
								data={this.state.tableData}
								selectableRows
								expandableRows
								columns={columns} filterable
								defaultFilterMethod={(filter, row) =>
									String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())}
								defaultPageSize={this.state.tableData.length > 10 ? 10 : this.state.tableData.length}
								pageSize={this.state.tableData.length > 10 ? 10 : this.state.tableData.length}
								showPagination={this.state.tableData.length > 10 ? true : false}
								showPageSizeOptions={false}
								className="-striped -highlight"
							/>
						</div>
					</div>


					<div className="loader" style={{ display: (showing ? 'block' : 'none') }}>
						loading...
						<Loader
							type="Bars"
							color="#4286f4"
							height="60"
							width="60"
						/>
					</div>



					<div className="filters">

						<div className="textInputControls">
							<div>
								<label className="rightsideLableControl">Date Range </label>
							</div>
							<div>
								<DatePicker placeholderText="Start date" className="historicalDatepicker" onChange={this.handleStartDateChange} selected={this.state.startDate} />
								<DatePicker placeholderText="End date" id="dPEnd" name="dpEnd" className="historicalDatepicker" onChange={this.handleEndDateChange} selected={this.state.endDate} />
							</div>
						</div>

						<div className="spacer"></div>

						<div className="textInputControls">
							<div>
								<label className="rightsideLableControl" >Title </label>
							</div>
							<div>
								<textarea placeholder="Enter a title" onBlur={this.handleTitleChange.bind(this)} className="textarea"></textarea>
							</div>
						</div>

						<div className="textInputControls">
							<div>
								<label className="rightsideLableControl" >Description </label>
							</div>
							<div>
								<textarea placeholder="Enter a description" onBlur={this.handleDescriptionChange.bind(this)} className="textarea"></textarea>
							</div>
						</div>


						<div className="spacer"></div>

						<div className="dropdownControls">
							<div>
								<label className="rightsideLableControl" >Room </label>
							</div>
							<div>
								<select className="selectorDefault" onChange={this.handleRoomChange}>
									<option>Select a room</option>
									{this.state.rooms.map(room => {
										//bId = room.buildingId;
										return <option key={room.id} building-id={room.buildingId} room-id={room.id} value={room.value}>{room.name}</option>;
									})}
								</select>
							</div>
						</div>

						<div className="dropdownControls">
							<div>
								<label className="rightsideLableControl" >Room Type</label>
							</div>
							<div>
								<select className="selectorDefault" onChange={this.handleRoomTypeChange}>
									<option>Select a room type</option>
									{this.state.roomTypes.map(roomTypes => {
										return <option key={roomTypes.id} roomtypes-id={roomTypes.id} value={roomTypes.value}>{roomTypes.name}</option>;
									})}
								</select>
							</div>
						</div>


						<div className="dropdownControls">
							<div>
								<label className="rightsideLableControl" >Reservation Type</label>
							</div>
							<div>
								<select className="selectorDefault" onChange={this.handleReservationTypeChange}>
									<option>Select a reservation type</option>
									{this.state.reservationTypes.map(reservation => {
										return <option key={reservation.id} reservationtype-id={reservation.id} value={reservation.value}>{reservation.name}</option>;
									})}
								</select>
							</div>
						</div>


						<div className="dropdownControls">
							<button className="btnPrimary" onClick={this.getSchedules}>Get Schedules</button>
							<button className="btnPrimary" onClick={this.handleUserExport} style={{ display: (showDownload ? 'inline-block' : 'none') }} >Download</button>
						</div>


					</div>
				</div>
			</div>

		);
	}
}
export default Historical;



// WEBPACK FOOTER //
// ./src/Pages/Search/historical.js